import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { baseUrl } from '../../../environments/environment';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  apiUrl: any;
  responseData: any;
  showlogin: boolean;
  showcontent: boolean;
  swalType: any;
  swalTitle: any;
  swalbackground: any;
  logoname: string;
  footerImg: string;
  constructor(public http: HttpClient, public snackBar: MatSnackBar,
    public route: ActivatedRoute, public router: Router) {
    // this.basePath = 'http://192.168.43.53:8081/';
    // this.apiUrl = this.basePath + 'nrfsi/nissan/';
    // this.apiUrl = '../../../../assets/restJSON/';
    this.apiUrl = baseUrl;
  }

  public setFooterImage() {
    if (window.localStorage.getItem('theme-name') !== null) {
      this.footerImg = window.localStorage.getItem('theme-name');
    } else {
      this.footerImg = 'nissan_default';
    }
    return this.footerImg;
  }

  public setLogoName() {
    if (window.localStorage.getItem('theme-name') !== null) {
      this.logoname = window.localStorage.getItem('theme-name');
    } else {
      this.logoname = 'nissan';
    }
    return this.logoname;
  }


  public applyColors(bgColor, btnFontColor, tabColor, tabFontColor) {
    window.localStorage.setItem('bg-color', bgColor);
    window.localStorage.setItem('btn-font-color', btnFontColor);
    window.localStorage.setItem('tab-color', tabColor);
    window.localStorage.setItem('tab-font-color', tabFontColor);
    this.setTheme();
    this.setLogoName();
  }

  public setTheme() {
    if (window.localStorage.getItem('bg-color') !== null) {
      document.documentElement.style.setProperty('--bg-color', window.localStorage.getItem('bg-color'));
    }
    if (window.localStorage.getItem('btn-font-color') !== null) {
      document.documentElement.style.setProperty('--btn-font-color', window.localStorage.getItem('btn-font-color'));
    }
    if (window.localStorage.getItem('tab-color') !== null) {
      document.documentElement.style.setProperty('--tab-color', window.localStorage.getItem('tab-color'));
    }
    if (window.localStorage.getItem('tab-font-color') !== null) {
      document.documentElement.style.setProperty('--tab-font-color', window.localStorage.getItem('tab-font-color'));
    }
  }

  public removeLocalStorage() {
    window.localStorage.removeItem('bg-color');
    window.localStorage.removeItem('btn-font-color');
    window.localStorage.removeItem('tab-color');
    window.localStorage.removeItem('tab-font-color');
    window.localStorage.removeItem('theme-name');
    window.localStorage.removeItem('logoImage');
    this.setTheme();
  }

  public openSnackBar(message: string, action: string, className: string) {
    this.snackBar.open(message, action, {
      duration: 8000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [className]
    });
  }

  public setLocalStorage(brand) {
    console.log("'logoImage', data.brands ", brand)
    if (brand === 'nissan') {
      this.applyColors('#C3002F', '#FFFFFF', '#EEEEEE', '#4C4C4C');
    } else if (brand === 'renault') {
      this.applyColors('#FFCC33', '#000000', '#000000', '#FFFFFF');
    } else if (brand === 'datsun') {
      this.applyColors('#273486', '#FFFFFF', '#EEEEEE', '#4C4C4C');
    } else if (brand === 'datsun_nissan_renault' || brand === 'datsun_nissan' || brand === 'datsun_renault' || brand === 'nissan_renault') {
      this.applyColors('#C3002F', '#FFFFFF', '#EEEEEE', '#4C4C4C');
    } else {
      this.applyColors('#C3002F', '#FFFFFF', '#EEEEEE', '#4C4C4C');
    }
  }

  getXData(path) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json', 'cache-control': 'no-cache'
      });
      this.http.get(this.apiUrl + path, { headers: headers })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status === 401) {
            this.router.navigate(['/home']);
          }
          reject(err);
        });
    });
  }

  postData(credentials, type) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders(
        { 'Content-Type': 'application/json', 'cache-control': 'no-cache' }
      );
      this.http.post(this.apiUrl + type, credentials, { headers: headers })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status === 401) {
            this.router.navigate(['/home']);
          }
          reject(err);
        });

    });
  }

}
